import React from 'react'

export default function Page404() {
    return (
        <div className='d-flex justify-content-center align-items-center' style={{height:"calc(100vh - 10.5rem)"}}>
            <h4>404 page not found</h4>
        </div>
    )
}
